export const appInfoData = {
  uae: {
    qrCodeImage: "QR.svg",
    playStoreImage: "playStore.png",
    appStoreImage: "appStore.png",
    appInfoImage: "AppInfo.svg"
  }
};